import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MinuteRequestService } from '../../sub-page/minutes/service/minute-request.service';
import { MinuteRequestSnapshotDTO, nuevaDescripcion } from '../../../files-clients/sub-page/minutes/interface/minute-detail';
import Swal from 'sweetalert2';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-modificar-descripcion',
  templateUrl: './modificar-descripcion.component.html',
  styleUrls: ['./modificar-descripcion.component.scss']
})
export class ModificarDescripcionComponent {
  public idMinute: number;
  public nuevaMinuta: nuevaDescripcion;

  constructor(@Inject(MAT_DIALOG_DATA) public data: number, public dialogRef: MatDialogRef<ModificarDescripcionComponent>, private service: MinuteRequestService, private route: ActivatedRoute,) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      this.idMinute = params['id'] | 0;
    });
  }

 formNuevaDescripcion = new FormGroup({
  description: new FormControl('', [Validators.required]),
  });

  submit() {
    var { description } = this.formNuevaDescripcion.value;
    this.nuevaMinuta = { minuteRequestId:this.idMinute, description: description };
    this.service.updateDescription(this.idMinute, this.nuevaMinuta).subscribe({
      next: (next) => {
        Swal.fire({
          title: 'Descripcion Actualizada',
          icon: 'success',
        })
        this.cerrarDialogo();
      },
      error: (error) => {
        Swal.fire({
          title: 'Error',
          text: error.error,
          icon: 'error',
        });
      },

    });
  }

  cerrarDialogo() {
    this.dialogRef.close();
  }

}